import { Table } from '@themesberg/react-bootstrap'
import React from 'react'
import { getTextColor } from '../../utils/dashboardEffects'
import { getDateTime , convertToEasternFormat} from '../../utils/dateFormatter'


export default ({ KPISummary }) => {
  return (
    <div style={{ overflow: 'auto', maxHeight: '385px' }}>
      <Table striped hover size='sm' className='text-center mt-4'>
        <thead className='thead-light'>
          <tr>
            <th className='text-left'>Name</th>
            <th>Last Received</th>
            <th>Expiry</th>
            <th>Pending Amount</th>
            <th>RollOver</th>
            <th>Available Bonus</th>
          </tr>
        </thead>

        <tbody>
          {KPISummary && KPISummary?.map(({
            name, lastReceived, expiry, pendingAmount, rollOver, availableBonus
          }, index) => {
            return (
              <tr key={index}>
                <td className='text-left'>{name}</td>
                <td className={
                  (lastReceived)}>{convertToEasternFormat(lastReceived)}</td>
                <td className={getTextColor(expiry)}>{expiry}</td>
                <td className={getTextColor(pendingAmount)}>{'$ '}{pendingAmount}</td>
                <td className={getTextColor(rollOver)}>{'$ '}{rollOver}</td>
                <td className={getTextColor(availableBonus)}>{'$ '}{availableBonus}</td>
              </tr>
            )
          })}
        </tbody>

        {
          KPISummary?.length < 1 && (
            <tr>
              <td colSpan={7} className='text-danger text-center'>
                No data found
              </td>
            </tr>)
        }

      </Table>
    </div>
  )
}
